import { IGetAccountData } from './auth/users'
import {
  AccountsType,
  IAccountWithDefault,
} from 'src/hooks/useSelectedAccounts'

export interface IStorage {
  user?: IGetAccountData
  accountsConfig?: {
    [key in AccountsType]?: IAccountWithDefault[]
  }
}

export const getInitialStorage = (): IStorage => {
  return {
    user: undefined,
  }
}

export const LOCAL_STORAGE_KEY = 'cusman-storage'

export const getStorage = (): IStorage => {
  const sessionData = localStorage.getItem(LOCAL_STORAGE_KEY)

  if (!sessionData) {
    return getInitialStorage()
  }

  try {
    const storage = JSON.parse(sessionData)

    return {
      ...getInitialStorage(),
      ...storage,
    }
  } catch (e) {
    console.error('invalid local storage')

    return getInitialStorage()
  }
}

export const setStorage = (storage: IStorage) => {
  try {
    const prevStorage = getStorage() || getInitialStorage()
    const toUpdatedStorage = { ...prevStorage, ...storage }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(toUpdatedStorage))
  } catch (e) {
    console.error(e)
  }
}

export const clearStorage = () => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(getInitialStorage()))

    Object.keys(localStorage).map((key) => {
      if (key.includes('storage/objects')) {
        localStorage.removeItem(key)
      }
    })

    localStorage.removeItem('app')
    localStorage.removeItem('cusman-storage')
  } catch (e) {
    console.error(e)
  }
}
